import { useEffect, useState } from "react";
import ContentsTopHeader from "../../../components/common/contents.top.header";
import {
  BackupFolderContainer,
  ContentsBody,
} from "../../../style/contents/backup/backup";
import { useLocation, useParams } from "react-router-dom";
import {
  fetchBackupFolderList,
  fetchBackupFolderListUser,
  fetchBackupUserListLoad,
  fetchFilePathDelete,
  fetchRequestWormDirectory,
} from "../../../api/admin";
import { BackupUser } from "./backup.user";
import { fetchLoadClientLogin } from "../../../api/auth";
import FolderList from "../../../components/backup/folder.list";
import { useAuthStore } from "../../../atoms/user.auth.store";
import ModalCenterLayout from "../../../components/modal/modal.center.layout";

type BackupUserList = BackupUser[];

export interface BackupFolder {
  createDate: string;
  name: string;
  rootDirectoryPath: string;
}

const BackupFolderList = () => {
  const { role } = useAuthStore(); // ✅ role 가져오기

  const [userData, setUserData] = useState<BackupUserList>([]);
  const [loginToken, setloginToken] = useState("");
  const [folderList, setFolderList] = useState<BackupFolder[]>([]);
  const [selectedFolders, setSelectedFolders] = useState<string[]>([]);
  const [wormTargetPath, setWormTargetPath] = useState("");
  const [wormModal, setWormModal] = useState({
    isOpen: false,
    isVisible: false,
  });

  console.log(folderList);

  const location = useLocation();
  const { deviceId } = useParams<{ deviceId: string }>();
  const queryParams = new URLSearchParams(location.search);

  const userName = decodeURIComponent(atob(queryParams.get("name") || ""));
  const department = decodeURIComponent(
    atob(queryParams.get("department") || ""),
  );
  const pcName = decodeURIComponent(atob(queryParams.get("pcName") || ""));

  const id = queryParams.get("id");
  const userAccount = queryParams.get("userAccount");

  useEffect(() => {
    const loadUserList = async () => {
      const userId = localStorage.getItem("userId");
      const companyCode = localStorage.getItem("companyCode");

      const response = await fetchBackupUserListLoad(
        Number(userId),
        companyCode || "",
      );
      setUserData(response.userList);
    };
    loadUserList();
  }, []);

  useEffect(() => {
    const loadUserLogin = async () => {
      const companyCode = localStorage.getItem("companyCode");

      // ✅ userData 배열에서 userAccount가 일치하는 항목 찾기
      const matchedUser = userData.find(
        (user) => user.userAccount === userAccount,
      );

      if (!matchedUser) {
        console.warn("해당 userAccount에 대한 유저 정보를 찾을 수 없습니다.");
        return;
      }

      const password = matchedUser.password;

      const requestData = {
        companyCode: companyCode || "",
        userAccount: matchedUser.userAccount,
        password: password,
        deviceId: "", // 백업용 deviceId는 이후 필요 시 추가
      };
      console.log(requestData);

      try {
        const response = await fetchLoadClientLogin(requestData);

        console.log(response);
        setloginToken(response.jwtToken);
      } catch (err) {
        console.error("🚨 로그인 실패:", err);
      }
    };

    // 🔒 ✅ admin이고 userData가 존재하며 id가 있을 때만 실행
    if (role === "admin" && userData.length > 0 && id) {
      loadUserLogin();
    }
  }, [userData]);

  // ✅ Admin 전용 폴더 로딩
  useEffect(() => {
    const loadFolderList = async () => {
      try {
        const response = await fetchBackupFolderList(
          Number(id),
          deviceId || "",
          loginToken || "",
        );
        setFolderList(response.message.rootDirectoryList);
      } catch (err) {
        console.error("❌ Admin 폴더 불러오기 실패:", err);
      }
    };

    if (role === "admin" && loginToken) {
      loadFolderList();
    }
  }, [loginToken, role, id, deviceId]);

  // ✅ User 전용 폴더 로딩
  useEffect(() => {
    const loadFolderListUser = async () => {
      try {
        const res = await fetchBackupFolderListUser(Number(id), deviceId || "");
        setFolderList(res.message.rootDirectoryList);
      } catch (err) {
        console.error("❌ User 폴더 불러오기 실패:", err);
      }
    };

    if (role === "user") {
      loadFolderListUser();
    }
  }, [role, id, deviceId]);

  const handleSelectChange = (rootDirectoryPath: string, checked: boolean) => {
    setSelectedFolders((prev) =>
      checked
        ? [...prev, rootDirectoryPath]
        : prev.filter((path) => path !== rootDirectoryPath),
    );
  };

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      setSelectedFolders(folderList.map((d) => d.rootDirectoryPath));
    } else {
      setSelectedFolders([]);
    }
  };

  const isAllSelected =
    folderList.length > 0 && selectedFolders.length === folderList.length;

  const handleDeleteFolders = async () => {
    if (selectedFolders.length === 0) {
      alert("삭제할 폴더를 선택해주세요.");
      return;
    }

    const adminUserId = localStorage.getItem("userId") ?? "";
    const companyCode = localStorage.getItem("companyCode") ?? "";

    try {
      await Promise.all(
        selectedFolders.map(async (folderName) => {
          const folder = folderList.find(
            (f) => f.rootDirectoryPath === folderName,
          );
          if (!folder) return;

          console.log(adminUserId, id, deviceId, folder.rootDirectoryPath);

          const res = await fetchFilePathDelete(
            adminUserId,
            id || "", // targetUserId
            deviceId || "", // targetDeviceId
            folder.rootDirectoryPath,
            companyCode,
          );

          console.log(`✅ 폴더 삭제 완료: ${folderName}`, res);
        }),
      );

      alert("선택한 폴더가 삭제되었습니다.");
      setSelectedFolders([]); // ✅ 선택 초기화

      // ✅ 폴더 목록 다시 불러오기
      const refreshed = await fetchBackupFolderList(
        Number(id),
        deviceId || "",
        loginToken || "",
      );
      setFolderList(refreshed.message.rootDirectoryList);
    } catch (err) {
      console.error("🚨 폴더 삭제 실패:", err);
      alert("삭제 중 오류가 발생했습니다.");
    }
  };

  const handleOpenWormModal = (directoryPath: string) => {
    setWormTargetPath(directoryPath);
    setWormModal({ isOpen: true, isVisible: true });
  };

  const handleCloseWormModal = () => {
    setWormModal({ isOpen: false, isVisible: false });
    setWormTargetPath("");
  };

  const handleRequestWormDirectory = async () => {
    if (!id || !deviceId) {
      alert("사용자 또는 디바이스 정보가 없습니다.");
      return;
    }

    if (!loginToken) {
      alert("로그인 토큰 정보가 없습니다.");
      return;
    }

    if (!wormTargetPath) {
      alert("WORM 요청할 폴더 정보가 없습니다.");
      return;
    }

    const params = {
      deviceId,
      directoryPath: wormTargetPath,
    };

    try {
      console.log("[BackupFolderList WORM] request params", {
        userId: id,
        ...params,
      });

      await fetchRequestWormDirectory(id, params, loginToken);

      alert("WORM 요청이 접수되었습니다.");
      handleCloseWormModal();
    } catch (err) {
      console.error("WORM 디렉토리 요청 실패:", err);
      alert("WORM 요청 중 오류가 발생했습니다.");
    }
  };

  return (
    <BackupFolderContainer>
      <ContentsTopHeader
        title="디바이스 목록 > 백업 파일 목록"
        backArrowPath={
          role === "admin" ? "/backup/user" : `/backup/device/${id}`
        }
      />
      <ContentsBody>
        {/* 파일 삭제 hide 처리 추후 논의 진행 후 다시 적용할 지 결졍 */}
        {/* <div className="top-components">
          <div className="l">
            {role === "admin" && (
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={(e) => handleSelectAll(e.target.checked)}
                id="allSelect"
              />
            )}
            {role === "admin" ? (
              <label htmlFor="allSelect">
                전체 선택 (0 / {folderList && folderList.length})
              </label>
            ) : (
              <label htmlFor="allSelect">
                전체 {folderList && folderList.length}
              </label>
            )}
          </div>
          {role === "admin" && (
            <div className="r">
              <button
                disabled={selectedFolders.length === 0}
                onClick={handleDeleteFolders}
              >
                선택 삭제
              </button>
            </div>
          )}
        </div> */}
        <div className="hr"></div>
        <FolderList
          data={folderList}
          userData={userData}
          selectedFolders={selectedFolders}
          onChange={handleSelectChange}
          deviceId={deviceId}
          id={id || ""}
          userAccount={userAccount || ""}
          role={role || ""}
          userName={userName}
          department={department}
          pcName={pcName}
          onRequestWorm={handleOpenWormModal}
        />
      </ContentsBody>
      {wormModal.isOpen && (
        <ModalCenterLayout
          isVisible={wormModal.isVisible}
          closedHandler={handleCloseWormModal}
          size="s"
        >
          <div className="worm-confirm-modal">
            <div className="modal-header">
              <h3>WORM 기능 적용</h3>
              <button
                type="button"
                className="closed-modal-btn"
                onClick={handleCloseWormModal}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <p>
                적용하시겠습니까? <br /> worm 기능이 적용되면 이미 저장된
                데이터의 수정/삭제가 불가능하게 됩니다.
              </p>
            </div>
            <div className="modal-actions">
              <button
                type="button"
                className="cancel"
                onClick={handleCloseWormModal}
              >
                취소
              </button>
              <button
                type="button"
                className="confirm"
                onClick={handleRequestWormDirectory}
              >
                적용
              </button>
            </div>
          </div>
        </ModalCenterLayout>
      )}
    </BackupFolderContainer>
  );
};

export default BackupFolderList;
